import { useLanguageContext } from '../i18n/LanguageProvider';

export function useTranslation() {
  const { t, language, setLanguage } = useLanguageContext();
  return { t, language, setLanguage };
} 